import { Skeleton } from '../../../components/Skeleton';

export function PatientActivitySkeleton() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
        <div className="flex flex-col items-center md:items-start">
          <Skeleton className="h-[40px] w-[250px]" />
          <Skeleton className="mt-2 flex h-[20px] w-[150px]" />
        </div>
        <div className="flex gap-5">
          <Skeleton className="h-[50px] w-[50px] md:w-[180px]" />
          <Skeleton className="h-[50px] w-[50px] md:w-[180px]" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-4 pt-4 md:flex-row md:gap-4">
        <Skeleton className="h-[40px] w-full md:w-[400px]" />
        <Skeleton className="h-[40px] w-full md:w-[350px]" />
      </div>

      <Skeleton className="mt-5 h-[500px] w-full" />
    </div>
  );
}
